import { defineComponent, unref, resolveComponent, computed, ref } from 'vue';import { useStore } from 'vuex';import { useRoute } from 'vue-router';import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a44fb656"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main_wrap"
};
const _hoisted_2 = {
  class: "page-name"
};
const _hoisted_3 = {
  class: "main-content-box"
};
const _hoisted_4 = {
  class: "main-content scroll_bar"
};
import Header from './header/index.vue';
import Sidebar from './sidebar/index.vue';
import Footer from './footer/index.vue';
import confirmMsg from '@/views/base/confirmErrMsg.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      getters,
      state
    } = useStore();
    const sideStatus = computed(() => getters['moduleCommon/getSideStatus']); // 隐藏左侧列表
    const router = useRoute();
    const pageTitle = computed(() => getters['moduleCommon/getPagetTitle']);
    const token = state.moduleCommon.token;
    const confirmMsgShow = state.moduleCommon.confirmErrMsgObj;
    // 判断当前框架页面
    const modifyClass = () => {
      let retCalss = '';
      // 判断是否未登录的底部页面
      if (!token && router.path.indexOf('/footerWebs') !== -1) {
        return 'small-no-menu-frame-layout';
      }
      if (!sideStatus.value) {
        retCalss = 'no-menu-frame-layout';
      }
      return retCalss;
    };
    return (_ctx, _cache) => {
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_footer = _resolveComponent("el-footer");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _directive_load = _resolveDirective("load");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["common-layout", modifyClass()])
      }, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_header, null, {
          default: _withCtx(() => [_renderSlot(_ctx.$slots, "header", {}, () => [_createVNode(Header)])]),
          _: 3
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_unref(sideStatus) ? (_openBlock(), _createBlock(_component_el_aside, {
            key: 0,
            width: "200px"
          }, {
            default: _withCtx(() => [_renderSlot(_ctx.$slots, "sidebar", {}, () => [_createVNode(Sidebar)])]),
            _: 3
          })) : _createCommentVNode("", true), _createVNode(_component_el_container, {
            class: "page-component-content"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_renderSlot(_ctx.$slots, "pageTitle", {}, () => [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(pageTitle) || _unref(router).meta?.title), 1)])]), _createVNode(_component_el_main, {
              id: "mainContent",
              ref: "mainContent",
              class: "scroll_bar"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_unref(confirmMsgShow).show ? (_openBlock(), _createBlock(confirmMsg, {
                key: 0
              })) : _createCommentVNode("", true), _createVNode(_component_router_view)]), _createVNode(_component_el_footer, null, {
                default: _withCtx(() => [_createVNode(Footer)]),
                _: 1
              })])]),
              _: 1
            }, 512)]),
            _: 3
          })]),
          _: 3
        })]),
        _: 3
      })], 2)), [[_directive_load, _unref(state).moduleCommon.httpLoading]]);
    };
  }
});